"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M0 14h2V2H0v12zm6 0h1V2H6v12zm2 0h1V2H8v12zm-5 0h2V2H3v12zM15 2v12h1V2h-1zm-5 12h1V2h-1v12zm2 0h2V2h-2v12z"];
//# sourceMappingURL=barcode.js.map